import React from 'react';
import Facets from '../Features/Facets/Facets';
import PaginationContainer from './PaginationContainer';
import PageNumbers from './PageNumbers';
import { AttributesParamShape, PaginationPropShape, ResultShape } from '../Infrastructure/propShapes'
import MoreButton from './MoreButton';
import PreviousButton from './PreviousButton';
import { translateResourceString } from '../../util/translationUtility';

const ProductSearchResultsContainer = ({
    attributes,
    onAttributeChange,
    onClearAttributes,
    pagination,
    paginationFirstItemIndex,
    onCurrentItemsPerPageChange,
    onCurrentSortByChange,
    onCurrentPageIndexChange,
    results,
    onLoadMoreOrPrevious,
    onResultClick,
    onShowMobileFacetsToggle,
    expandedFacets,
    onToggleFacetExpanded,
    showMoreFacets,
    onToggleShowMoreFacet,
    additionalBlocks,
    isFiltered,
    containerData,
    addToCartEndPoint,
    loginPageUrl,
    isUserLoggedIn,
    isOrderRequestOnlyMarket,
    wishlistData,
    updateLists,
    toggleAddToListModal,
    setAddToListLinkClass,
    tileContainer
}) => {
    const showMore = pagination.resultsTotal > paginationFirstItemIndex + pagination.currentItemsOnPage;

    const GridComponent = tileContainer;

    const facets = attributes ? attributes.length > 0 : false;

    const showClearAttributes = attributes.filter(
        attribute => attribute.values.filter(
            value => value.checked).length > 0).length > 0;

    const paginationOrLoadMoreButton = pagination
        ? containerData && containerData.UseLoadMoreButton
            ? showMore
                ? <div className="row">
                    <div className="col-12 text-center">
                        <MoreButton onClick={() => onLoadMoreOrPrevious(false)} />
                    </div>
                </div>
                : null
            : <PageNumbers pagination={pagination} onCurrentPageIndexChange={onCurrentPageIndexChange} />
        : null;

    return (
        <div className="row search-results-container">

            <div className="facets-wrapper col-lg-3 d-none d-lg-block">
                {facets &&
                    <Facets
                        attributes={attributes}
                        onAttributeChange={onAttributeChange}
                        onClearAttributes={onClearAttributes}
                        expandedFacets={expandedFacets}
                        onToggleFacetExpanded={onToggleFacetExpanded}
                        showMoreFacets={showMoreFacets}
                        onToggleShowMoreFacet={onToggleShowMoreFacet}
                    />
                }
            </div>

            <div className="product-list__wrapper col-12 col-lg-9">

                <div className="mb-4 category-list-top-pagination-wrapper">
                    <PaginationContainer
                        pagination={pagination}
                        paginationFirstItemIndex={paginationFirstItemIndex}
                        showClearAttributes={showClearAttributes}
                        onClearAttributes={onClearAttributes}
                        onCurrentSortByChange={onCurrentSortByChange}
                        onAttributeChange={onAttributeChange}
                        onShowMobileFacetsToggle={onShowMobileFacetsToggle}
                        attributes={attributes}
                        useLoadMoreButton={containerData.UseLoadMoreButton}
                    />
                </div>

                {(containerData.UseLoadMoreButton && paginationFirstItemIndex > 0) &&
                    <div className="row mb-3">
                        <div className="col-12 text-center">
                            <PreviousButton onClick={() => onLoadMoreOrPrevious(true)} />
                        </div>
                    </div>
                }

                <div className="row">
                    <div className="product-list col-12 js-product-list">
                        {pagination.resultsTotal > 0
                            ? <GridComponent
                                results={results}
                                onResultClick={onResultClick}
                                additionalBlocks={additionalBlocks}
                                isFiltered={isFiltered}
                                addToCartEndPoint={addToCartEndPoint}
                                loginPageUrl={loginPageUrl}
                                isUserLoggedIn={isUserLoggedIn}
                                isOrderRequestOnlyMarket={isOrderRequestOnlyMarket}
                                wishlistData={wishlistData}
                                updateLists={updateLists}
                                toggleAddToListModal={toggleAddToListModal}
                            />
                            : <p className="no-results-with-filters">{translateResourceString("/Search/NoResultsWithFilters")}</p>
                        }
                    </div>
                </div>

                {paginationOrLoadMoreButton}

            </div>

        </div>
    );
};

ProductSearchResultsContainer.propType = {
    ...AttributesParamShape,
    ...PaginationPropShape,
    ...ResultShape
};

export default ProductSearchResultsContainer;
